// "use client";
// import { useEffect, useState, useRef } from "react";

// export default function ViewerWithVideo() {
//   const [stage, setStage] = useState("video"); // "video" | "loading" | "svg"
//   const [activeCluster, setActiveCluster] = useState(null);
//   const [svgName, setSvgName] = useState("MUGHARRAQ5");
//   const [svgContent, setSvgContent] = useState("");
//   const videoRef = useRef(null);
//   const [isFading, setIsFading] = useState(false);
//   const canvasRef = useRef(null);
//   const [loading, setLoading] = useState(false);
//   const [resourcesLoaded, setResourcesLoaded] = useState(false);
//   const [imageLoading, setImageLoading] = useState(false);

//   const clickableClusters = [
//     "Workers2",
//     "Workers1",
//     "EngineersManagers",
//     "Supervisors",
//     "Technicians",
//     "Mosque",
//     "Swimming_Pool",
//     "Aquatics",
//     "clinic",
//     "recreation",
//     "kitchen",
//     "dining_hall",
//     "playground",
//     "title_Swimming_Pool"
//   ];

//   // 🧭 Read ?file= param
//   useEffect(() => {
//     if (typeof window === "undefined") return;
//     const params = new URLSearchParams(window.location.search);
//     const file = params.get("file");
//     if (file) setSvgName(file);
//   }, []);

//   // 📥 Preload resources when video starts
//   useEffect(() => {
//     if (stage !== "video" || resourcesLoaded) return;

//     const preloadResources = async () => {
//       try {
//         // Preload loading image
//         const loadingImg = new Image();
//         loadingImg.src = "/image_loading.jpg";
//         await new Promise((resolve, reject) => {
//           loadingImg.onload = resolve;
//           loadingImg.onerror = reject;
//         });

//         // Preload SVG
//         const svgResponse = await fetch(`/svgs/${svgName}.svg`);
//         if (!svgResponse.ok) throw new Error(`HTTP ${svgResponse.status}`);

//         setResourcesLoaded(true);
//         console.log("Resources preloaded successfully");
//       } catch (err) {
//         console.error("Preload error:", err);
//         // Continue anyway even if preload fails
//         setResourcesLoaded(true);
//       }
//     };

//     preloadResources();
//   }, [stage, svgName, resourcesLoaded]);

//   // 🎬 Pause at 10 seconds automatically
//   useEffect(() => {
//     if (stage !== "video" || !videoRef.current) return;
//     const video = videoRef.current;

//     let pausedOnce = false;

//     const checkTime = () => {
//       // setStage("loading");
//       if (!pausedOnce && video.currentTime >= 13) {
//         video.pause();
//         pausedOnce = true;
//         if (video.parentElement) {
//           video.parentElement.style.cursor = "pointer";
//         }
//       }

//       if (video.currentTime < 13) {
//         if (video.parentElement) {
//           video.parentElement.style.cursor = "default";
//         }
//       }

//       if (video.currentTime >= 18) {
//         setStage("loading");
//       }
//     };

//     video.addEventListener("timeupdate", checkTime);

//     // When video ends, show loading
//     video.addEventListener("ended", () => {
//       const canvas = canvasRef.current;
//       if (canvas) {
//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//       }

//       setIsFading(true);

//       setTimeout(() => {
//         setStage("loading");
//         setIsFading(false);
//       }, 500);
//     });

//     return () => {
//       video.removeEventListener("timeupdate", checkTime);
//     };
//   }, [stage]);

//   // 🧩 Load SVG when stage changes to loading
//   useEffect(() => {
//     if (stage !== "loading" || !svgName) return;

//     let cancelled = false;

//     const loadSVG = async () => {
//       setLoading(true);
//       try {
//         const res = await fetch(`/svgs/${svgName}.svg`);
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const text = await res.text();

//         const color = "#2b6cb0";
//         const updated = text.replace(
//           '<g id="Title_clinic"',
//           `<g id="Title_clinic" style="--clinicColor:${color}"`
//         );

//         if (!cancelled) {
//           setSvgContent(updated);
//           // Wait a moment for SVG to process, then show it
//           setTimeout(() => {
//             if (!cancelled) {
//               setStage("svg");
//               setLoading(false);
//             }
//           }, 100);
//         }
//       } catch (err) {
//         console.error("Failed to load SVG:", err);
//         if (!cancelled) {
//           setSvgContent("");
//           setStage("svg");
//           setLoading(false);
//         }
//       }
//     };

//     loadSVG();
//     return () => {
//       cancelled = true;
//     };
//   }, [stage, svgName]);

//   // ▶️ Resume video on click
//   const handleVideoClick = () => {
//     if (!videoRef.current) return;
//     const video = videoRef.current;
//     if (video.paused) {
//       video.play();
//       if (video.parentElement) {
//         video.parentElement.style.cursor = "default";
//       }
//     }
//   };

//   // 🧠 SVG Interactivity
//   // useEffect(() => {
//   //   if (stage !== "svg" || !svgContent) return;
//   //   const svg = document.querySelector("svg");
//   //   if (!svg) return;

//   //   const clusters = svg.querySelectorAll(
//   //     "g[id]:not([id^='logo']):not([id^='text']):not([id^='Title']):not([id^='title']):not([id^='GB']):not([id^='Layer_18']):not([id^='logo']):not([id^='fill']):not([id^='line'])"
//   //   );

//   //   const cleanups = [];

//   //   clusters.forEach((g) => {
//   //     console.log("Cluster found:", g.id);
//   //     if (clickableClusters.includes(g.id)) {
//   //       g.style.cursor = "pointer";
//   //     } else {
//   //       g.style.cursor = "default";
//   //     }

//   //     const enter = () => {
//   //       if (g.id !== activeCluster) {
//   //         g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//   //           el.style.fill = "rgba(146, 26, 29, 0.35)";
//   //           el.style.transition = "fill 0.3s ease";
//   //         });
//   //       }
//   //     };

//   //     const leave = () => {
//   //       if (g.id !== activeCluster) {
//   //         g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//   //           el.style.fill = "transparent";
//   //         });
//   //       }
//   //     };

//   //     // const click = async () => {
//   //     //   console.log("Clicked cluster:", g.id);
//   //     //   clusters.forEach((other) =>
//   //     //     other.querySelectorAll("path, polygon, polyline").forEach((el) => {
//   //     //       el.style.fill = "transparent";
//   //     //     })
//   //     //   );
//   //     //   g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//   //     //     el.style.fill = "rgba(37,99,235,0.4)";
//   //     //   });
//   //     //   const imagePath = `/images/${g.id}.png`;
//   //     //   const exists = await imageExists(imagePath);

//   //     //   if (exists) {
//   //     //     setActiveCluster(g.id);
//   //     //   } else {
//   //     //     console.warn("⚠️ No image found for", g.id);
//   //     //   }
//   //     // };

//   //     const click = async () => {
//   //       console.log("Clicked cluster:", g.id);
//   //       clusters.forEach((other) =>
//   //         other.querySelectorAll("path, polygon, polyline").forEach((el) => {
//   //           el.style.fill = "transparent";
//   //         })
//   //       );
//   //       g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//   //         el.style.fill = "rgba(37,99,235,0.4)";
//   //       });
//   //       const imagePath = `/images/${g.id}.png`;
//   //       const exists = await imageExists(imagePath);

//   //       if (exists) {
//   //         setImageLoading(true); // start loading before showing
//   //         setActiveCluster(g.id);
//   //       } else {
//   //         console.warn("⚠️ No image found for", g.id);
//   //       }
//   //     };
//   //     g.addEventListener("mouseenter", enter);
//   //     g.addEventListener("mouseleave", leave);
//   //     g.addEventListener("click", click);

//   //     cleanups.push(() => {
//   //       g.removeEventListener("mouseenter", enter);
//   //       g.removeEventListener("mouseleave", leave);
//   //       g.removeEventListener("click", click);
//   //     });
//   //   });

//   //   return () => cleanups.forEach((fn) => fn());
//   // }, [stage, svgContent, activeCluster]);


//   useEffect(() => {
//     if (stage !== "svg" || !svgContent) return;
//     const svg = document.querySelector("svg");
//     if (!svg) return;

//     const clusters = svg.querySelectorAll(
//       "g[id]:not([id^='logo']):not([id^='text']):not([id^='GB']):not([id^='Layer_18']):not([id^='fill']):not([id^='line'])"
//     );

//     const cleanups = [];

//     clusters.forEach((g) => {
//       const id = g.id.trim();
//       const isTitle = /^title_/i.test(id) || /^Title_/i.test(id);

//       // 🔗 Find the related cluster/title pair (e.g. Swimming_Pool <-> title_Swimming_Pool)
//       const baseId = id.replace(/^title_/i, "").replace(/^Title_/i, "");
//       const relatedId = isTitle ? baseId : `title_${baseId}`;
//       const relatedGroup =
//         svg.querySelector(`g[id='${relatedId}']`) ||
//         svg.querySelector(`g[id='Title_${baseId}']`);

//       // ✅ Mark clickable if either in the list
//       if (clickableClusters.includes(baseId)) {
//         g.style.cursor = "pointer";
//         if (relatedGroup) relatedGroup.style.cursor = "pointer";
//       } else {
//         g.style.cursor = "default";
//         if (relatedGroup) relatedGroup.style.cursor = "default";
//       }

//       // 🩵 Hover effects (only for main clusters)
//       const enter = () => {
//         if (!isTitle && g.id !== activeCluster) {
//           g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "rgba(146, 26, 29, 0.35)";
//             el.style.transition = "fill 0.3s ease";
//           });
//         }
//       };
//       const leave = () => {
//         if (!isTitle && g.id !== activeCluster) {
//           g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "transparent";
//           });
//         }
//       };

//       // 🖱️ Unified click handler for cluster and title
//       const handleClick = async () => {
//         if (!clickableClusters.includes(baseId)) return;

//         console.log("Clicked cluster or title:", baseId);

//         // Clear fills for all clusters
//         clusters.forEach((other) =>
//           other.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "transparent";
//           })
//         );

//         // Highlight both cluster and title
//         const mainGroup =
//           svg.querySelector(`g[id='${baseId}']`) ||
//           svg.querySelector(`g[id='${baseId.charAt(0).toUpperCase() + baseId.slice(1)}']`);
//         const titleGroup =
//           svg.querySelector(`g[id='title_${baseId}']`) ||
//           svg.querySelector(`g[id='Title_${baseId}']`);

//         [mainGroup, titleGroup].forEach((grp) => {
//           if (!grp) return;
//           grp.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "rgba(37,99,235,0.4)";
//           });
//         });

//         const imagePath = `/images/${baseId}.png`;
//         const exists = await imageExists(imagePath);

//         if (exists) {
//           setImageLoading(true);
//           setActiveCluster(baseId);
//         } else {
//           console.warn("⚠️ No image found for", baseId);
//         }
//       };

//       // 🧩 Event bindings
//       g.addEventListener("mouseenter", enter);
//       g.addEventListener("mouseleave", leave);
//       g.addEventListener("click", handleClick);
//       if (relatedGroup) relatedGroup.addEventListener("click", handleClick);

//       cleanups.push(() => {
//         g.removeEventListener("mouseenter", enter);
//         g.removeEventListener("mouseleave", leave);
//         g.removeEventListener("click", handleClick);
//         if (relatedGroup) relatedGroup.removeEventListener("click", handleClick);
//       });
//     });

//     return () => cleanups.forEach((fn) => fn());
//   }, [stage, svgContent, activeCluster]);

//   async function imageExists(url) {
//     try {
//       const res = await fetch(url, { method: "GET" });
//       const contentType = res.headers.get("Content-Type") || "";
//       if (!res.ok || !contentType.startsWith("image")) return false;
//       return true;
//     } catch (err) {
//       console.warn("Image check failed:", url, err);
//       return false;
//     }
//   }

//   useEffect(() => {
//     if (stage !== "svg" || !svgContent || activeCluster) return;

//     const svgElement = document.querySelector("svg");
//     if (!svgElement) return;

//     const style = document.createElement("style");
//     style.textContent = `
//     @keyframes pulse {
//       0% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//       50% { fill: rgba(146,26,29,0.5); stroke-width: 4; }
//       100% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//     }

//     g[id].auto-highlight path,
//     g[id].auto-highlight polygon,
//     g[id].auto-highlight rect,
//     g[id].auto-highlight polyline {
//       animation: pulse 1.2s infinite;
//     }
//   `;
//     svgElement.appendChild(style);

//     const allGroups = svgElement.querySelectorAll("g[id]");
//     const groups = Array.from(allGroups).filter(g => {
//       const id = g.id.trim();
//       return !/^(logo|text|title|layer_18|gb|bg|fill|line)/i.test(id);
//     });

//     console.log("Filtered groups:", groups.map(g => g.id));
//     if (groups.length === 0) return;

//     let index = 0;
//     let interval = null;
//     let idleTimer = null;
//     let isPaused = false;

//     const highlightNext = () => {
//       groups.forEach((g, i) => g.classList.toggle("auto-highlight", i === index));
//       index = (index + 1) % groups.length;
//     };

//     const startLoop = () => {
//       clearInterval(interval);
//       highlightNext();
//       interval = setInterval(highlightNext, 1200);
//       isPaused = false;
//     };

//     const stopLoop = () => {
//       clearInterval(interval);
//       groups.forEach((g) => g.classList.remove("auto-highlight"));
//       isPaused = true;
//     };

//     const handleClick = () => stopLoop();
//     const handleMouseMove = () => {
//       if (isPaused) return;
//       stopLoop();
//       clearTimeout(idleTimer);
//       idleTimer = setTimeout(() => {
//         if (!activeCluster) startLoop();
//       }, 5000);
//     };

//     startLoop();
//     svgElement.addEventListener("click", handleClick);
//     window.addEventListener("mousemove", handleMouseMove);

//     return () => {
//       clearInterval(interval);
//       clearTimeout(idleTimer);
//       svgElement.removeEventListener("click", handleClick);
//       window.removeEventListener("mousemove", handleMouseMove);
//     };
//   }, [stage, svgContent, activeCluster]);


//   // 🖼️ Render
//   return (
//     <div className="relative w-full h-screen bg-black overflow-hidden">
//       {/* Fade Transition Overlay */}
//       <div className={`fade-overlay ${isFading ? "active" : ""}`} />

//       {/* Canvas (freeze frame) */}
//       <canvas
//         ref={canvasRef}
//         width={1920}
//         height={1080}
//         className={`absolute inset-0 w-full h-full object-cover ${stage === "video" ? "block" : "hidden"
//           }`}
//       />

//       {/* 🎬 Video */}
//       {stage === "video" && (
//         <div
//           className="relative w-full h-screen cursor-pointer overflow-hidden"
//           onClick={handleVideoClick}
//         >
//           <video
//             ref={videoRef}
//             src="/videos/intro_2.mp4"
//             className="w-full h-full object-cover"
//             autoPlay
//             muted
//             playsInline
//           />
//         </div>
//       )}

//       {/* 🧭 Loading Spinner */}
//       {(stage === "loading" || (stage === "svg" && loading)) && (
//         <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black overflow-hidden">
//           <img
//             src="/image_loading.jpg"
//             alt="Loading..."
//             className="max-w-full max-h-full w-auto h-auto object-contain"
//           />
//         </div>
//       )}

//       {/* 🧭 SVG Viewer */}
//       {stage === "svg" && !loading && (
//         <div
//           className="fade-in relative w-full h-screen bg-black overflow-hidden flex items-center justify-center"
//           dangerouslySetInnerHTML={{ __html: svgContent }}
//         />
//       )}

//       {/* 🪟 Cluster Popup */}
//       {/* {stage === "svg" && activeCluster && (
//         <div
//           className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
//           style={{ background: "rgba(0,0,0,0.8)" }}
//           onClick={() => setActiveCluster(null)}
//         >
//           <div className="relative" onClick={(e) => e.stopPropagation()}>
//             <img
//               src={`/images/${activeCluster}.png`}
//               alt={activeCluster}
//               className="object-contain rounded-2xl shadow-2xl"
//               style={{ maxWidth: "80vw", maxHeight: "80vh" }}
//             />
//             <button
//               onClick={() => setActiveCluster(null)}
//               className="absolute bottom-10 left-10 bg-transparent hover:opacity-80 transition-all"
//               aria-label="Close"
//               title="Close"
//               style={{ width: "4vw", height: "4vw" }}
//             >
//               <img
//                 src="/images/button.png"
//                 alt="Close"
//                 className="w-full h-full object-contain"
//               />
//             </button>
//           </div>
//         </div>
//       )} */}
//       {stage === "svg" && activeCluster && (
//         <div
//           className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
//           style={{ background: "rgba(0,0,0,0.8)" }}
//           onClick={() => setActiveCluster(null)}
//         >
//           <div className="relative" onClick={(e) => e.stopPropagation()}>
//             {/* 🔄 Loading state */}
//             {imageLoading && (
//               <div className="absolute inset-0 flex items-center justify-center bg-black/60 rounded-2xl">
//                 <img
//                   src="/logo-Bp5Gjupu.png"
//                   alt="Loading..."
//                   className="max-w-[60%] object-contain animate-pulse"
//                 />
//               </div>
//             )}

//             {/* 🖼️ Main cluster image */}
//             <img
//               src={`/images/${activeCluster}.png`}
//               alt={activeCluster}
//               className="object-contain rounded-2xl shadow-2xl"
//               style={{ maxWidth: "80vw", maxHeight: "80vh" }}
//               onLoad={() => setImageLoading(false)}
//               onError={() => setImageLoading(false)}
//             />

//             {/* ❌ Close button */}
//             <button
//               onClick={() => setActiveCluster(null)}
//               className="absolute bottom-10 left-10 bg-transparent hover:opacity-80 transition-all"
//               aria-label="Close"
//               title="Close"
//               style={{ width: "4vw", height: "4vw" }}
//             >
//               <img
//                 src="/images/button.png"
//                 alt="Close"
//                 className="w-full h-full object-contain"
//               />
//             </button>
//           </div>
//         </div>
//       )}
//       {/* 🎨 Styling */}
//       <style>{`
//         /* Prevent scrolling globally */
//         html, body {
//           margin: 0;
//           padding: 0;
//           overflow: hidden;
//           height: 100%;
//           width: 100%;
//         }

//         #root {
//           height: 100vh;
//           width: 100vw;
//           overflow: hidden;
//         }

//         g[id="logo"],
//         g[id="logo"] *,
//         g[id^="logo"],
//         g[id^="logo"] * {
//           fill: #ffffff !important;
//           stroke: none !important;
//           opacity: 1 !important;
//           pointer-events: none !important;
//         }

//         /* ============================================================
//            🟦 CLUSTERS — invisible by default, exclude Title_ layers
//            ============================================================ */
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) path,
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) polygon,
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) rect,
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) polyline {
//           fill: transparent;
//           stroke-width: 2;
//           transition: fill .3s ease, stroke-width .3s ease;
//         }

//         /* ============================================================
//            📌 TITLE_ LAYERS — static, always visible, non-interactive
//            ============================================================ */
//         g[id^="Title"], g[id^="title"] {
//           pointer-events: auto !important; /* was: none */
//         }
//         g[id^="Title"] *, g[id^="title"] * {
//           transition: none !important; 
//           opacity: 1 !important;
//         }

//         /* ============================================================
//            ✨ AUTO-HIGHLIGHT ANIMATION (pulse)
//            ============================================================ */
//         @keyframes pulse {
//           0% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//           50% { fill: rgba(146,26,29,0.5); stroke-width: 4; }
//           100% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//         }
//         g[id].auto-highlight path,
//         g[id].auto-highlight polygon,
//         g[id].auto-highlight rect,
//         g[id].auto-highlight polyline {
//           animation: pulse 1.2s infinite;
//         }

//         /* ============================================================
//            🎬 VIDEO + SVG GENERAL STYLING
//            ============================================================ */
//         video {
//           width: 100%;
//           height: 100vh;
//           object-fit: cover;
//         }

//         svg {
//           width: 100% !important;
//           height: 100vh !important;
//           display: block;
//           overflow: hidden;
//         }

//         img.fade-in {
//           animation: fadeIn 1s ease-in-out;
//         }

//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         /* ============================================================
//            🤍 TEXT LAYERS
//            ============================================================ */
//         g[id^="text"] * {
//           stroke: none !important;
//         }

//         /* White text */
//         g[id^="text"] [id="white"],
//         g[id^="text"] path#white {
//           fill: #ffffff !important;
//         }

//         g[id^="logo"] * {
//           stroke: none !important;
//         }

//         /* White logo */
//         g[id^="logo"] [id="white"],
//         g[id^="logo"] path#white {
//           fill: #ffffff !important;
//         }

//         /* Red text */
//         g[id^="text"] [id="color"],
//         g[id^="text"] path#color {
//           fill: #8f1a1e !important;
//         }

//         /* Mosque override */
//         g[id^="Mosque1"] [id="color"],
//         g[id^="Mosque1"] path#color {
//           fill: #ffffff !important;
//         }
//         g[id^="Mosque1"] [id="color"],
//         g[id^="Mosque1"] rect#color {
//           fill: #8f1a1e !important;
//         }

//         /* Worker override */
//         g[id^="Worker_x2019_s"] [id="color"],
//         g[id^="Worker_x2019_s"] rect#color {
//           fill: #8f1a1e !important;
//         }
//         g[id^="Worker_x2019_s"] [id="white"],
//         g[id^="Worker_x2019_s"] rect#white {
//           fill: #ffffff !important;
//         }
//         g[id^="Title"], g[id^="title"] {
//   pointer-events: auto !important; /* was: none */
//         }

//         g[id^="Title"] rect,
//         g[id^="Title"] polygon,
//         g[id^="title"] rect,
//         g[id^="title"] polygon {
//           fill: #8f1a1e !important;
//           stroke: none !important;
//         }

//         g[id^="Title"] path,
//         g[id^="title"] path {
//           fill: #ffffff !important;
//           stroke: none !important;
//         }

//         g[id="Title_Mosque"] rect[x="7004.21"][y="1452.51"],
//         g[id="Title_Mosque"] rect[x="7511.13"][y="1555.97"] {
//           fill: white !important;
//         }

//         g[id="title_playground"] rect[x="5946.01"][y="2669.69"],
//         g[id="title_playground"] rect[x="6984.08"][y="2669.67"] {
//           fill: white !important;
//         }

//         g[id="Title_dining_hall"] rect[x="4264.12"][y="3933.55"] {
//           fill: white !important;
//         }

//         g[id="Title_RUNNING_TRACK"] rect[x="1503.72"][y="3079.34"],
//         g[id="Title_RUNNING_TRACK"] rect[x="1501.98"][y="3079.34"] {
//           fill: white !important;
//         }

//         // g[id="Title_kitchen"] rect[x="4342.15"][y="2929.29"] {
//         //   fill: white !important;
//         // }

//         // g[id="Title_recreation"] rect[x="4370.21"][y="2353.77"] {
//         //   fill: white !important;
//         // }

//         g[id="title_EngineersManagers"] rect[x="5652.89"][y="1192.74"],
//         g[id="title_EngineersManagers"] rect[x="7285.54"][y="1109.46"] {
//           fill: white !important;
//         }

//         g[id="Title_clinic"] rect[x="6515.38"][y="2085.59"],
//         g[id="Title_clinic"] rect[x="7693.2"][y="2013.48"] {
//           fill: white !important;
//         }

//         .fade-in {
//           opacity: 0;
//           animation: fadeIn 0.6s ease forwards;
//         }

//         @keyframes fadeIn {
//           to { opacity: 1; }
//         }

//         .fade-overlay {
//           position: absolute;
//           inset: 0;
//           background-color: black;
//           opacity: 0;
//           pointer-events: none;
//           transition: opacity 0.5s ease-in-out;
//           z-index: 100;
//         }

//         .fade-overlay.active {
//           opacity: 0.7;
//         }
//       `}</style>
//     </div>
//   );
// }


// before click in 10 seconds
// "use client";
// import { useEffect, useState, useRef } from "react";

// export default function ViewerWithVideo() {
//   const [stage, setStage] = useState("video"); // "video" | "loading" | "svg"
//   const [activeCluster, setActiveCluster] = useState(null);
//   const [svgName, setSvgName] = useState("MUGHARRAQ5");
//   const [svgContent, setSvgContent] = useState("");
//   const videoRef = useRef(null);
//   const [isFading, setIsFading] = useState(false);
//   const canvasRef = useRef(null);
//   const [loading, setLoading] = useState(false);
//   const [resourcesLoaded, setResourcesLoaded] = useState(false);
//   const [imageLoading, setImageLoading] = useState(false);

//   // Image cache to prevent repeated HTTP requests
//   const imageCache = useRef(new Map());

//   const clickableClusters = [
//     "Workers2",
//     "Workers1",
//     "EngineersManagers",
//     "Supervisors",
//     "Technicians",
//     "Mosque",
//     "Swimming_Pool",
//     "Aquatics",
//     "clinic",
//     "recreation",
//     "kitchen",
//     "dining_hall",
//     "playground",
//     "title_Swimming_Pool"
//   ];

//   // Image preloading function
//   const preloadImage = (imagePath) => {
//     return new Promise((resolve) => {
//       // Check if already cached
//       if (imageCache.current.has(imagePath)) {
//         resolve(true);
//         return;
//       }

//       const img = new Image();
//       img.onload = () => {
//         imageCache.current.set(imagePath, {
//           src: imagePath,
//           loaded: true,
//           element: img
//         });
//         console.log("✅ Image preloaded:", imagePath);
//         resolve(true);
//       };
//       img.onerror = () => {
//         console.warn("❌ Failed to preload image:", imagePath);
//         imageCache.current.set(imagePath, { loaded: false, src: imagePath });
//         resolve(false);
//       };
//       img.src = imagePath;
//     });
//   };

//   // Check if image exists (with caching)
//   async function imageExists(url) {
//     // Check cache first
//     if (imageCache.current.has(url)) {
//       return imageCache.current.get(url).loaded;
//     }

//     try {
//       const res = await fetch(url, { method: "HEAD" });
//       const contentType = res.headers.get("Content-Type") || "";
//       const exists = res.ok && contentType.startsWith("image");

//       if (exists) {
//         // Pre-cache the URL
//         imageCache.current.set(url, { loaded: true, src: url });
//       }

//       return exists;
//     } catch (err) {
//       console.warn("Image check failed:", url, err);
//       return false;
//     }
//   }

//   // 🧭 Read ?file= param
//   useEffect(() => {
//     if (typeof window === "undefined") return;
//     const params = new URLSearchParams(window.location.search);
//     const file = params.get("file");
//     if (file) setSvgName(file);
//   }, []);

//   // 📥 Preload resources when video starts
//   useEffect(() => {
//     if (stage !== "video" || resourcesLoaded) return;

//     const preloadResources = async () => {
//       try {
//         // Preload loading image
//         const loadingImg = new Image();
//         loadingImg.src = "/image_loading.jpg";
//         await new Promise((resolve, reject) => {
//           loadingImg.onload = resolve;
//           loadingImg.onerror = reject;
//         });

//         // Preload SVG
//         const svgResponse = await fetch(`/svgs/${svgName}.svg`);
//         if (!svgResponse.ok) throw new Error(`HTTP ${svgResponse.status}`);

//         setResourcesLoaded(true);
//         console.log("Resources preloaded successfully");
//       } catch (err) {
//         console.error("Preload error:", err);
//         // Continue anyway even if preload fails
//         setResourcesLoaded(true);
//       }
//     };

//     preloadResources();
//   }, [stage, svgName, resourcesLoaded]);

//   // 🎬 Pause at 10 seconds automatically
//   useEffect(() => {
//     if (stage !== "video" || !videoRef.current) return;
//     const video = videoRef.current;

//     let pausedOnce = false;

//     const checkTime = () => {
//       if (!pausedOnce && video.currentTime >= 13) {
//         video.pause();
//         pausedOnce = true;
//         if (video.parentElement) {
//           video.parentElement.style.cursor = "pointer";
//         }
//       }

//       if (video.currentTime < 13) {
//         if (video.parentElement) {
//           video.parentElement.style.cursor = "default";
//         }
//       }

//       if (video.currentTime >= 18) {
//         setStage("loading");
//       }
//     };

//     video.addEventListener("timeupdate", checkTime);

//     // When video ends, show loading
//     video.addEventListener("ended", () => {
//       const canvas = canvasRef.current;
//       if (canvas) {
//         const ctx = canvas.getContext("2d");
//         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//       }

//       setIsFading(true);

//       setTimeout(() => {
//         setStage("loading");
//         setIsFading(false);
//       }, 500);
//     });

//     return () => {
//       video.removeEventListener("timeupdate", checkTime);
//     };
//   }, [stage]);

//   // 🧩 Load SVG when stage changes to loading
//   useEffect(() => {
//     if (stage !== "loading" || !svgName) return;

//     let cancelled = false;

//     const loadSVG = async () => {
//       setLoading(true);
//       try {
//         const res = await fetch(`/svgs/${svgName}.svg`);
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const text = await res.text();

//         const color = "#2b6cb0";
//         const updated = text.replace(
//           '<g id="Title_clinic"',
//           `<g id="Title_clinic" style="--clinicColor:${color}"`
//         );

//         if (!cancelled) {
//           setSvgContent(updated);

//           // Preload all cluster images in background when SVG loads
//           setTimeout(async () => {
//             console.log("🔄 Preloading all cluster images...");
//             for (const cluster of clickableClusters) {
//               const imagePath = `/images/${cluster}.png`;
//               await preloadImage(imagePath);
//             }
//             console.log("✅ All images preloaded");
//           }, 0);

//           // Wait a moment for SVG to process, then show it
//           setTimeout(() => {
//             if (!cancelled) {
//               setStage("svg");
//               setLoading(false);
//             }
//           }, 100);
//         }
//       } catch (err) {
//         console.error("Failed to load SVG:", err);
//         if (!cancelled) {
//           setSvgContent("");
//           setStage("svg");
//           setLoading(false);
//         }
//       }
//     };

//     loadSVG();
//     return () => {
//       cancelled = true;
//     };
//   }, [stage, svgName]);

//   // ▶️ Resume video on click
//   const handleVideoClick = () => {
//     if (!videoRef.current) return;
//     const video = videoRef.current;
//     if (video.paused) {
//       video.play();
//       if (video.parentElement) {
//         video.parentElement.style.cursor = "default";
//       }
//     }
//   };

//   // 🧠 SVG Interactivity
//   useEffect(() => {
//     if (stage !== "svg" || !svgContent) return;
//     const svg = document.querySelector("svg");
//     if (!svg) return;

//     const clusters = svg.querySelectorAll(
//       "g[id]:not([id^='logo']):not([id^='text']):not([id^='GB']):not([id^='Layer_18']):not([id^='fill']):not([id^='line'])"
//     );

//     const cleanups = [];

//     clusters.forEach((g) => {
//       const id = g.id.trim();
//       const isTitle = /^title_/i.test(id) || /^Title_/i.test(id);
//       const baseId = id.replace(/^title_/i, "").replace(/^Title_/i, "");

//       // 🔗 Find the related cluster/title pair
//       const relatedId = isTitle ? baseId : `title_${baseId}`;
//       const relatedGroup =
//         svg.querySelector(`g[id='${relatedId}']`) ||
//         svg.querySelector(`g[id='Title_${baseId}']`);

//       // ✅ Mark clickable if either in the list
//       if (clickableClusters.includes(baseId)) {
//         g.style.cursor = "pointer";
//         if (relatedGroup) relatedGroup.style.cursor = "pointer";
//       } else {
//         g.style.cursor = "default";
//         if (relatedGroup) relatedGroup.style.cursor = "default";
//       }

//       // 🩵 Hover effects (only for main clusters)
//       const enter = () => {
//         if (!isTitle && g.id !== activeCluster) {
//           g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "rgba(146, 26, 29, 0.35)";
//             el.style.transition = "fill 0.3s ease";
//           });
//         }
//       };

//       const leave = () => {
//         if (!isTitle && g.id !== activeCluster) {
//           g.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "transparent";
//           });
//         }
//       };

//       // 🖱️ Unified click handler for cluster and title
//       const handleClick = async () => {
//         const clusterId = clickableClusters.includes(baseId) ? baseId : id;
//         if (!clickableClusters.includes(clusterId)) return;

//         console.log("🖱️ Clicked cluster or title:", clusterId);
//         console.log("📦 Cache status:", imageCache.current.has(`/images/${clusterId}.png`));

//         // Clear fills for all clusters
//         clusters.forEach((other) =>
//           other.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "transparent";
//           })
//         );

//         // Highlight both cluster and title
//         const mainGroup =
//           svg.querySelector(`g[id='${clusterId}']`) ||
//           svg.querySelector(`g[id='${clusterId.charAt(0).toUpperCase() + clusterId.slice(1)}']`);
//         const titleGroup =
//           svg.querySelector(`g[id='title_${clusterId}']`) ||
//           svg.querySelector(`g[id='Title_${clusterId}']`);

//         [mainGroup, titleGroup].forEach((grp) => {
//           if (!grp) return;
//           grp.querySelectorAll("path, polygon, polyline").forEach((el) => {
//             el.style.fill = "rgba(37,99,235,0.4)";
//           });
//         });

//         const imagePath = `/images/${clusterId}.png`;

//         // Check cache first
//         const cachedImage = imageCache.current.get(imagePath);

//         if (cachedImage && cachedImage.loaded) {
//           // Image is cached and loaded - show immediately
//           console.log("⚡ Using cached image");
//           setActiveCluster(clusterId);
//           setImageLoading(false);
//         } else {
//           // Image not cached or failed to load previously
//           console.log("🔄 Loading image from server");
//           setImageLoading(true);
//           setActiveCluster(clusterId);

//           // Try to load and cache the image
//           const success = await preloadImage(imagePath);
//           if (!success) {
//             console.warn("⚠️ No image found for", clusterId);
//           }
//           setImageLoading(false);
//         }
//       };

//       // 🧩 Event bindings
//       g.addEventListener("mouseenter", enter);
//       g.addEventListener("mouseleave", leave);
//       g.addEventListener("click", handleClick);

//       if (relatedGroup) {
//         relatedGroup.addEventListener("click", handleClick);
//       }

//       cleanups.push(() => {
//         g.removeEventListener("mouseenter", enter);
//         g.removeEventListener("mouseleave", leave);
//         g.removeEventListener("click", handleClick);
//         if (relatedGroup) relatedGroup.removeEventListener("click", handleClick);
//       });
//     });

//     return () => cleanups.forEach((fn) => fn());
//   }, [stage, svgContent, activeCluster]);

//   // ✨ Auto-highlight animation for clusters
//   useEffect(() => {
//     if (stage !== "svg" || !svgContent || activeCluster) return;

//     const svgElement = document.querySelector("svg");
//     if (!svgElement) return;

//     const style = document.createElement("style");
//     style.textContent = `
//       @keyframes pulse {
//         0% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//         50% { fill: rgba(146,26,29,0.5); stroke-width: 4; }
//         100% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//       }

//       g[id].auto-highlight path,
//       g[id].auto-highlight polygon,
//       g[id].auto-highlight rect,
//       g[id].auto-highlight polyline {
//         animation: pulse 1.2s infinite;
//       }
//     `;
//     svgElement.appendChild(style);

//     const allGroups = svgElement.querySelectorAll("g[id]");
//     const groups = Array.from(allGroups).filter(g => {
//       const id = g.id.trim();
//       return !/^(logo|text|title|layer_18|gb|bg|fill|line)/i.test(id);
//     });

//     console.log("Filtered groups for auto-highlight:", groups.map(g => g.id));
//     if (groups.length === 0) return;

//     let index = 0;
//     let interval = null;
//     let idleTimer = null;
//     let isPaused = false;

//     const highlightNext = () => {
//       groups.forEach((g, i) => g.classList.toggle("auto-highlight", i === index));
//       index = (index + 1) % groups.length;
//     };

//     const startLoop = () => {
//       clearInterval(interval);
//       highlightNext();
//       interval = setInterval(highlightNext, 1200);
//       isPaused = false;
//     };

//     const stopLoop = () => {
//       clearInterval(interval);
//       groups.forEach((g) => g.classList.remove("auto-highlight"));
//       isPaused = true;
//     };

//     const handleClick = () => stopLoop();
//     const handleMouseMove = () => {
//       if (isPaused) return;
//       stopLoop();
//       clearTimeout(idleTimer);
//       idleTimer = setTimeout(() => {
//         if (!activeCluster) startLoop();
//       }, 5000);
//     };

//     startLoop();
//     svgElement.addEventListener("click", handleClick);
//     window.addEventListener("mousemove", handleMouseMove);

//     return () => {
//       clearInterval(interval);
//       clearTimeout(idleTimer);
//       svgElement.removeEventListener("click", handleClick);
//       window.removeEventListener("mousemove", handleMouseMove);
//     };
//   }, [stage, svgContent, activeCluster]);

//   // 🖼️ Render
//   return (
//     <div className="relative w-full h-screen bg-black overflow-hidden">
//       {/* Fade Transition Overlay */}
//       <div className={`fade-overlay ${isFading ? "active" : ""}`} />

//       {/* Canvas (freeze frame) */}
//       <canvas
//         ref={canvasRef}
//         width={1920}
//         height={1080}
//         className={`absolute inset-0 w-full h-full object-cover ${stage === "video" ? "block" : "hidden"
//           }`}
//       />

//       {/* 🎬 Video */}
//       {stage === "video" && (
//         <div
//           className="relative w-full h-screen cursor-pointer overflow-hidden"
//           onClick={handleVideoClick}
//         >
//           <video
//             ref={videoRef}
//             src="/videos/intro_2.mp4"
//             className="w-full h-full object-cover"
//             autoPlay
//             muted
//             playsInline
//           />
//         </div>
//       )}

//       {/* 🧭 Loading Spinner */}
//       {(stage === "loading" || (stage === "svg" && loading)) && (
//         <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black overflow-hidden">
//           <img
//             src="/image_loading.jpg"
//             alt="Loading..."
//             className="max-w-full max-h-full w-auto h-auto object-contain"
//           />
//         </div>
//       )}

//       {/* 🧭 SVG Viewer */}
//       {stage === "svg" && !loading && (
//         <div
//           className="fade-in relative w-full h-screen bg-black overflow-hidden flex items-center justify-center"
//           dangerouslySetInnerHTML={{ __html: svgContent }}
//         />
//       )}

//       {/* 🪟 Cluster Popup */}
//       {stage === "svg" && activeCluster && (
//         <div
//           className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
//           style={{ background: "rgba(0,0,0,0.9)" }}
//           onClick={() => {
//             setActiveCluster(null);
//             setImageLoading(false);
//           }}
//         >
//           <div className="relative" onClick={(e) => e.stopPropagation()}>
//             {/* 🔄 Loading state - Only show for non-cached images */}
//             {imageLoading && (
//               <div className="absolute inset-0 flex items-center justify-center bg-black/80 rounded-2xl z-10">
//                 <div className="text-center">
//                   <img
//                     src="/logo-Bp5Gjupu.png"
//                     alt="Loading..."
//                     className="max-w-[200px] object-contain animate-pulse mx-auto mb-4"
//                   />
//                   <div className="text-white text-lg font-semibold">Loading Image...</div>
//                 </div>
//               </div>
//             )}

//             {/* 🖼️ Main cluster image */}
//             <img
//               src={`/images/${activeCluster}.png`}
//               alt={activeCluster}
//               className={`object-contain rounded-2xl shadow-2xl transition-all duration-300 ${imageLoading ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
//                 }`}
//               style={{ maxWidth: "85vw", maxHeight: "85vh" }}
//               onLoad={() => {
//                 // Backup loading handler
//                 setImageLoading(false);
//               }}
//               onError={() => {
//                 setImageLoading(false);
//                 console.error("❌ Failed to load image:", activeCluster);
//               }}
//             />

//             <button
//               onClick={() => setActiveCluster(null)}
//               className="absolute bottom-10 left-10 bg-transparent hover:opacity-80 transition-all"
//               aria-label="Close"
//               title="Close"
//               style={{ width: "4vw", height: "4vw" }}
//             >
//               <img
//                 src="/images/button.png"
//                 alt="Close"
//                 className="w-full h-full object-contain"
//               />
//             </button>
//           </div>
//         </div>
//       )}

//       {/* 🎨 Styling */}
//       <style>{`
//         /* Prevent scrolling globally */
//         html, body {
//           margin: 0;
//           padding: 0;
//           overflow: hidden;
//           height: 100%;
//           width: 100%;
//         }

//         #root {
//           height: 100vh;
//           width: 100vw;
//           overflow: hidden;
//         }

//         g[id="logo"],
//         g[id="logo"] *,
//         g[id^="logo"],
//         g[id^="logo"] * {
//           fill: #ffffff !important;
//           stroke: none !important;
//           opacity: 1 !important;
//           pointer-events: none !important;
//         }

//         /* ============================================================
//            🟦 CLUSTERS — invisible by default, exclude Title_ layers
//            ============================================================ */
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) path,
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) polygon,
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) rect,
//         g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) polyline {
//           fill: transparent;
//           stroke-width: 2;
//           transition: fill .3s ease, stroke-width .3s ease;
//         }

//         /* ============================================================
//            📌 TITLE_ LAYERS — static, always visible, non-interactive
//            ============================================================ */
//         g[id^="Title"], g[id^="title"] {
//           pointer-events: auto !important;
//         }
//         g[id^="Title"] *, g[id^="title"] * {
//           transition: none !important; 
//           opacity: 1 !important;
//         }

//         /* ============================================================
//            ✨ AUTO-HIGHLIGHT ANIMATION (pulse)
//            ============================================================ */
//         @keyframes pulse {
//           0% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//           50% { fill: rgba(146,26,29,0.5); stroke-width: 4; }
//           100% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
//         }
//         g[id].auto-highlight path,
//         g[id].auto-highlight polygon,
//         g[id].auto-highlight rect,
//         g[id].auto-highlight polyline {
//           animation: pulse 1.2s infinite;
//         }

//         /* ============================================================
//            🎬 VIDEO + SVG GENERAL STYLING
//            ============================================================ */
//         video {
//           width: 100%;
//           height: 100vh;
//           object-fit: cover;
//         }

//         svg {
//           width: 100% !important;
//           height: 100vh !important;
//           display: block;
//           overflow: hidden;
//         }

//         img.fade-in {
//           animation: fadeIn 1s ease-in-out;
//         }

//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         /* ============================================================
//            🤍 TEXT LAYERS
//            ============================================================ */
//         g[id^="text"] * {
//           stroke: none !important;
//         }

//         /* White text */
//         g[id^="text"] [id="white"],
//         g[id^="text"] path#white {
//           fill: #ffffff !important;
//         }

//         g[id^="logo"] * {
//           stroke: none !important;
//         }

//         /* White logo */
//         g[id^="logo"] [id="white"],
//         g[id^="logo"] path#white {
//           fill: #ffffff !important;
//         }

//         /* Red text */
//         g[id^="text"] [id="color"],
//         g[id^="text"] path#color {
//           fill: #8f1a1e !important;
//         }

//         /* Mosque override */
//         g[id^="Mosque1"] [id="color"],
//         g[id^="Mosque1"] path#color {
//           fill: #ffffff !important;
//         }
//         g[id^="Mosque1"] [id="color"],
//         g[id^="Mosque1"] rect#color {
//           fill: #8f1a1e !important;
//         }

//         /* Worker override */
//         g[id^="Worker_x2019_s"] [id="color"],
//         g[id^="Worker_x2019_s"] rect#color {
//           fill: #8f1a1e !important;
//         }
//         g[id^="Worker_x2019_s"] [id="white"],
//         g[id^="Worker_x2019_s"] rect#white {
//           fill: #ffffff !important;
//         }
//         g[id^="Title"], g[id^="title"] {
//           pointer-events: auto !important;
//         }

//         g[id^="Title"] rect,
//         g[id^="Title"] polygon,
//         g[id^="title"] rect,
//         g[id^="title"] polygon {
//           fill: #8f1a1e !important;
//           stroke: none !important;
//         }

//         g[id^="Title"] path,
//         g[id^="title"] path {
//           fill: #ffffff !important;
//           stroke: none !important;
//         }

//         g[id="Title_Mosque"] rect[x="7004.21"][y="1452.51"],
//         g[id="Title_Mosque"] rect[x="7511.13"][y="1555.97"] {
//           fill: white !important;
//         }

//         g[id="title_playground"] rect[x="5946.01"][y="2669.69"],
//         g[id="title_playground"] rect[x="6984.08"][y="2669.67"] {
//           fill: white !important;
//         }

//         g[id="Title_dining_hall"] rect[x="4264.12"][y="3933.55"] {
//           fill: white !important;
//         }

//         g[id="Title_RUNNING_TRACK"] rect[x="1503.72"][y="3079.34"],
//         g[id="Title_RUNNING_TRACK"] rect[x="1501.98"][y="3079.34"] {
//           fill: white !important;
//         }

//         g[id="title_EngineersManagers"] rect[x="5652.89"][y="1192.74"],
//         g[id="title_EngineersManagers"] rect[x="7285.54"][y="1109.46"] {
//           fill: white !important;
//         }

//         g[id="Title_clinic"] rect[x="6515.38"][y="2085.59"],
//         g[id="Title_clinic"] rect[x="7693.2"][y="2013.48"] {
//           fill: white !important;
//         }

//         .fade-in {
//           opacity: 0;
//           animation: fadeIn 0.6s ease forwards;
//         }

//         @keyframes fadeIn {
//           to { opacity: 1; }
//         }

//         .fade-overlay {
//           position: absolute;
//           inset: 0;
//           background-color: black;
//           opacity: 0;
//           pointer-events: none;
//           transition: opacity 0.5s ease-in-out;
//           z-index: 100;
//         }

//         .fade-overlay.active {
//           opacity: 0.7;
//         }
//       `}</style>
//     </div>
//   );
// }





"use client";
import { useEffect, useState, useRef } from "react";

export default function ViewerWithVideo() {
  const [stage, setStage] = useState("video"); // "video" | "loading" | "svg"
  const [activeCluster, setActiveCluster] = useState(null);
  const [svgName, setSvgName] = useState("MUGHARRAQ5");
  const [svgContent, setSvgContent] = useState("");
  const videoRef = useRef(null);
  const [isFading, setIsFading] = useState(false);
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [resourcesLoaded, setResourcesLoaded] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  // Image cache to prevent repeated HTTP requests
  const imageCache = useRef(new Map());

  // Add state to track if user clicked after 10 seconds
  const [userClickedAfter10, setUserClickedAfter10] = useState(false);

  const clickableClusters = [
    "Workers2",
    "Workers1",
    "EngineersManagers",
    "Supervisors",
    "Technicians",
    "Mosque",
    "Swimming_Pool",
    "Aquatics",
    "clinic",
    "recreation",
    "kitchen",
    "dining_hall",
    "playground",
    "title_Swimming_Pool",
    "RUNNING_TRACK"
  ];

  // Image preloading function
  const preloadImage = (imagePath) => {
    return new Promise((resolve) => {
      // Check if already cached
      if (imageCache.current.has(imagePath)) {
        resolve(true);
        return;
      }

      const img = new Image();
      img.onload = () => {
        imageCache.current.set(imagePath, {
          src: imagePath,
          loaded: true,
          element: img
        });
        console.log("✅ Image preloaded:", imagePath);
        resolve(true);
      };
      img.onerror = () => {
        console.warn("❌ Failed to preload image:", imagePath);
        imageCache.current.set(imagePath, { loaded: false, src: imagePath });
        resolve(false);
      };
      img.src = imagePath;
    });
  };

  // Check if image exists (with caching)
  async function imageExists(url) {
    // Check cache first
    if (imageCache.current.has(url)) {
      return imageCache.current.get(url).loaded;
    }

    try {
      const res = await fetch(url, { method: "HEAD" });
      const contentType = res.headers.get("Content-Type") || "";
      const exists = res.ok && contentType.startsWith("image");

      if (exists) {
        // Pre-cache the URL
        imageCache.current.set(url, { loaded: true, src: url });
      }

      return exists;
    } catch (err) {
      console.warn("Image check failed:", url, err);
      return false;
    }
  }

  // 🧭 Read ?file= param
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const file = params.get("file");
    if (file) setSvgName(file);
  }, []);

  // 📥 Preload resources when video starts
  useEffect(() => {
    if (stage !== "video" || resourcesLoaded) return;

    const preloadResources = async () => {
      try {
        // Preload loading image
        const loadingImg = new Image();
        loadingImg.src = "/image_loading.jpg";
        await new Promise((resolve, reject) => {
          loadingImg.onload = resolve;
          loadingImg.onerror = reject;
        });

        // Preload SVG
        const svgResponse = await fetch(`/svgs/${svgName}.svg`);
        if (!svgResponse.ok) throw new Error(`HTTP ${svgResponse.status}`);

        setResourcesLoaded(true);
        console.log("Resources preloaded successfully");
      } catch (err) {
        console.error("Preload error:", err);
        // Continue anyway even if preload fails
        setResourcesLoaded(true);
      }
    };

    preloadResources();
  }, [stage, svgName, resourcesLoaded]);

  // 🎬 Video playback control with click detection
  useEffect(() => {
    if (stage !== "video" || !videoRef.current) return;
    const video = videoRef.current;

    let pausedOnce = false;

    const checkTime = () => {
      // If user clicked after 10 seconds, don't pause at 13 seconds
      if (!userClickedAfter10 && !pausedOnce && video.currentTime >= 13) {
        video.pause();
        pausedOnce = true;
        if (video.parentElement) {
          video.parentElement.style.cursor = "pointer";
        }
      }

      if (video.currentTime < 13) {
        if (video.parentElement) {
          video.parentElement.style.cursor = "default";
        }
      }

      // Always transition to loading at 18 seconds regardless of clicks
      if (video.currentTime >= 18) {
        setStage("loading");
      }
    };

    video.addEventListener("timeupdate", checkTime);

    // When video ends, show loading
    video.addEventListener("ended", () => {
      const canvas = canvasRef.current;
      if (canvas) {
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      }

      setIsFading(true);

      setTimeout(() => {
        setStage("loading");
        setIsFading(false);
      }, 500);
    });

    return () => {
      video.removeEventListener("timeupdate", checkTime);
    };
  }, [stage, userClickedAfter10]);

  // 🧩 Load SVG when stage changes to loading
  useEffect(() => {
    if (stage !== "loading" || !svgName) return;

    let cancelled = false;

    const loadSVG = async () => {
      setLoading(true);
      try {
        const res = await fetch(`/svgs/${svgName}.svg`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const text = await res.text();

        const color = "#2b6cb0";
        const updated = text.replace(
          '<g id="Title_clinic"',
          `<g id="Title_clinic" style="--clinicColor:${color}"`
        );

        if (!cancelled) {
          setSvgContent(updated);

          // Preload all cluster images in background when SVG loads
          setTimeout(async () => {
            for (const cluster of clickableClusters) {
              const imagePath = `/images/${cluster}.png`;
              await preloadImage(imagePath);
            }
          }, 0);

          // Wait a moment for SVG to process, then show it
          setTimeout(() => {
            if (!cancelled) {
              setStage("svg");
              setLoading(false);
            }
          }, 100);
        }
      } catch (err) {
        console.error("Failed to load SVG:", err);
        if (!cancelled) {
          setSvgContent("");
          setStage("svg");
          setLoading(false);
        }
      }
    };

    loadSVG();
    return () => {
      cancelled = true;
    };
  }, [stage, svgName]);

  // ▶️ Resume video on click with click tracking
  const handleVideoClick = () => {
    if (!videoRef.current) return;
    const video = videoRef.current;

    // Check if video is between 10-13 seconds and user clicks
    if (video.currentTime >= 10 && video.currentTime < 13) {
      setUserClickedAfter10(true);
    }

    if (video.paused) {
      video.play();
      if (video.parentElement) {
        video.parentElement.style.cursor = "default";
      }
    }
  };

  // 🧠 SVG Interactivity
  useEffect(() => {
    if (stage !== "svg" || !svgContent) return;
    const svg = document.querySelector("svg");
    if (!svg) return;

    const clusters = svg.querySelectorAll(
      "g[id]:not([id^='logo']):not([id^='text']):not([id^='GB']):not([id^='Layer_18']):not([id^='fill']):not([id^='line'])"
    );

    const cleanups = [];

    clusters.forEach((g) => {
      const id = g.id.trim();
      const isTitle = /^title_/i.test(id) || /^Title_/i.test(id);
      const baseId = id.replace(/^title_/i, "").replace(/^Title_/i, "");

      // 🔗 Find the related cluster/title pair
      const relatedId = isTitle ? baseId : `title_${baseId}`;
      const relatedGroup =
        svg.querySelector(`g[id='${relatedId}']`) ||
        svg.querySelector(`g[id='Title_${baseId}']`);

      // ✅ Mark clickable if either in the list
      if (clickableClusters.includes(baseId) || baseId == 'home') {
        g.style.cursor = "pointer";
        if (relatedGroup) relatedGroup.style.cursor = "pointer";
      } else {
        g.style.cursor = "default";
        if (relatedGroup) relatedGroup.style.cursor = "default";
      }

      // 🩵 Hover effects (only for main clusters)
      const enter = () => {
        if (!isTitle && g.id !== activeCluster) {
          g.querySelectorAll("path, polygon, polyline").forEach((el) => {
            el.style.fill = "rgba(146, 26, 29, 0.35)";
            el.style.transition = "fill 0.3s ease";
          });
        }
      };

      const leave = () => {
        if (!isTitle && g.id !== activeCluster) {
          g.querySelectorAll("path, polygon, polyline").forEach((el) => {
            el.style.fill = "transparent";
          });
        }
      };

      // 🖱️ Unified click handler for cluster and title
      const handleClick = async () => {
        const clusterId = clickableClusters.includes(baseId) ? baseId : id;
        console.log(clusterId) // home
        if (clusterId == 'home') { setStage('video') }
        if (!clickableClusters.includes(clusterId)) return;

        // Clear fills for all clusters
        clusters.forEach((other) =>
          other.querySelectorAll("path, polygon, polyline").forEach((el) => {
            el.style.fill = "transparent";
          })
        );

        // Highlight both cluster and title
        const mainGroup =
          svg.querySelector(`g[id='${clusterId}']`) ||
          svg.querySelector(`g[id='${clusterId.charAt(0).toUpperCase() + clusterId.slice(1)}']`);
        const titleGroup =
          svg.querySelector(`g[id='title_${clusterId}']`) ||
          svg.querySelector(`g[id='Title_${clusterId}']`);

        [mainGroup, titleGroup].forEach((grp) => {
          if (!grp) return;
          grp.querySelectorAll("path, polygon, polyline").forEach((el) => {
            el.style.fill = "rgba(37,99,235,0.4)";
          });
        });

        const imagePath = `/images/${clusterId}.png`;

        // Check cache first
        const cachedImage = imageCache.current.get(imagePath);

        if (cachedImage && cachedImage.loaded) {
          // Image is cached and loaded - show immediately
          console.log("⚡ Using cached image");
          setActiveCluster(clusterId);
          setImageLoading(false);
        } else {
          // Image not cached or failed to load previously
          console.log("🔄 Loading image from server");
          setImageLoading(true);
          setActiveCluster(clusterId);

          // Try to load and cache the image
          const success = await preloadImage(imagePath);
          if (!success) {
            console.warn("⚠️ No image found for", clusterId);
          }
          setImageLoading(false);
        }
      };

      // 🧩 Event bindings
      g.addEventListener("mouseenter", enter);
      g.addEventListener("mouseleave", leave);
      g.addEventListener("click", handleClick);

      if (relatedGroup) {
        relatedGroup.addEventListener("click", handleClick);
      }

      cleanups.push(() => {
        g.removeEventListener("mouseenter", enter);
        g.removeEventListener("mouseleave", leave);
        g.removeEventListener("click", handleClick);
        if (relatedGroup) relatedGroup.removeEventListener("click", handleClick);
      });
    });

    return () => cleanups.forEach((fn) => fn());
  }, [stage, svgContent, activeCluster]);

  // ✨ Auto-highlight animation for clusters
  useEffect(() => {
    if (stage !== "svg" || !svgContent || activeCluster) return;

    const svgElement = document.querySelector("svg");
    if (!svgElement) return;

    const style = document.createElement("style");
    style.textContent = `
      @keyframes pulse {
        0% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
        50% { fill: rgba(146,26,29,0.5); stroke-width: 4; }
        100% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
      }

      g[id].auto-highlight path,
      g[id].auto-highlight polygon,
      g[id].auto-highlight rect,
      g[id].auto-highlight polyline {
        animation: pulse 1.2s infinite;
      }
    `;
    svgElement.appendChild(style);

    const allGroups = svgElement.querySelectorAll("g[id]");
    const groups = Array.from(allGroups).filter(g => {
      const id = g.id.trim();
      return !/^(logo|text|title|layer_18|gb|bg|fill|line)/i.test(id);
    });

    console.log("Filtered groups for auto-highlight:", groups.map(g => g.id));
    if (groups.length === 0) return;

    let index = 0;
    let interval = null;
    let idleTimer = null;
    let isPaused = false;

    const highlightNext = () => {
      groups.forEach((g, i) => g.classList.toggle("auto-highlight", i === index));
      index = (index + 1) % groups.length;
    };

    const startLoop = () => {
      clearInterval(interval);
      highlightNext();
      interval = setInterval(highlightNext, 1200);
      isPaused = false;
    };

    const stopLoop = () => {
      clearInterval(interval);
      groups.forEach((g) => g.classList.remove("auto-highlight"));
      isPaused = true;
    };

    const handleClick = () => stopLoop();
    const handleMouseMove = () => {
      if (isPaused) return;
      stopLoop();
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        if (!activeCluster) startLoop();
      }, 5000);
    };

    startLoop();
    svgElement.addEventListener("click", handleClick);
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      clearInterval(interval);
      clearTimeout(idleTimer);
      svgElement.removeEventListener("click", handleClick);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [stage, svgContent, activeCluster]);

  // 🖼️ Render
  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      {/* Fade Transition Overlay */}
      <div className={`fade-overlay ${isFading ? "active" : ""}`} />

      {/* Canvas (freeze frame) */}
      <canvas
        ref={canvasRef}
        width={1920}
        height={1080}
        className={`absolute inset-0 w-full h-full object-cover ${stage === "video" ? "block" : "hidden"
          }`}
      />

      {/* 🎬 Video */}
      {stage === "video" && (
        <div
          className="relative w-full h-screen cursor-pointer overflow-hidden"
          onClick={handleVideoClick}
        >
          <video
            ref={videoRef}
            src="/videos/intro_2.mp4"
            className="w-full h-full object-cover"
            autoPlay
            muted
            playsInline
          />
        </div>
      )}

      {/* 🧭 Loading Spinner */}
      {(stage === "loading" || (stage === "svg" && loading)) && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black overflow-hidden">
          <img
            src="/image_loading.jpg"
            alt="Loading..."
            className="max-w-full max-h-full w-auto h-auto object-contain"
          />
        </div>
      )}

      {/* 🧭 SVG Viewer */}
      {stage === "svg" && !loading && (
        <div
          className="fade-in relative w-full h-screen bg-black overflow-hidden flex items-center justify-center"
          dangerouslySetInnerHTML={{ __html: svgContent }}
        />
      )}

      {/* 🪟 Cluster Popup */}
      {stage === "svg" && activeCluster && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
          style={{ background: "rgba(0,0,0,0.9)" }}
          onClick={() => {
            setActiveCluster(null);
            setImageLoading(false);
          }}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            {/* 🔄 Loading state - Only show for non-cached images */}
            {imageLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/80 rounded-2xl z-10">
                <div className="text-center">
                  <img
                    src="/logo-Bp5Gjupu.png"
                    alt="Loading..."
                    className="max-w-[200px] object-contain animate-pulse mx-auto mb-4"
                  />
                </div>
              </div>
            )}

            {/* 🖼️ Main cluster image */}
            <img
              src={`/images/${activeCluster}.png`}
              alt={activeCluster}
              className={`object-contain rounded-2xl shadow-2xl transition-all duration-300 ${imageLoading ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
                }`}
              style={{ maxWidth: "80vw", maxHeight: "80vh" }}
              onLoad={() => {
                // Backup loading handler
                setImageLoading(false);
              }}
              onError={() => {
                setImageLoading(false);
                console.error("❌ Failed to load image:", activeCluster);
              }}
            />

            {!imageLoading && (<button
              onClick={() => setActiveCluster(null)}
              className="absolute top-12 bg-transparent hover:opacity-80 transition-all mobile-back-button"
              aria-label="Close"
              title="Close"
              style={{ width: "2.3vw", height: "2.3vw", left: "3.5rem", top: "4rem" }}
            >
              <img
                src="/images/back.png"
                alt="Close"
                className="w-full h-full object-contain"
              />
            </button>)}
            {!imageLoading && (<button
              onClick={() => {
                setStage('video');
                setActiveCluster(null);
              }}
              className="absolute top-12 left-30 bg-transparent hover:opacity-80 transition-all mobile-home-button"
              aria-label="Close"
              title="Close"
              style={{ width: "2.3vw", height: "2.3vw", left: "8rem", top: "4rem" }}
            >
              <img
                src="/images/home.png"
                alt="Close"
                className="w-full h-full object-contain"
              />
            </button>)}

            {/* {!imageLoading && (<button
              onClick={() => window.open("https://sdeiragroup.ae", "_blank")}
              className="absolute bottom-10 bg-transparent hover:opacity-80 transition-all mobile-back-button"
              aria-label="Close"
              title="Close"
              style={{ width: "8vw", height: "3vw", right: "17rem" }}
            >
              <img
                src="/images/SdeiraGroup.png"
                alt="Close"
                className="w-full h-full object-contain"
              />
            </button>)} */}
          </div>
        </div>
      )
      }

      {/* 🎨 Styling */}
      <style>{`
        /* Prevent scrolling globally */
        html, body {
          margin: 0;
          padding: 0;
          overflow: hidden;
          height: 100%;
          width: 100%;
        }

        #root {
          height: 100vh;
          width: 100vw;
          overflow: hidden;
        }

        g[id="logo"],
        g[id="logo"] *,
        g[id^="logo"],
        g[id^="logo"] * {
          fill: #ffffff !important;
          stroke: none !important;
          opacity: 1 !important;
          pointer-events: none !important;
        }

        /* ============================================================
           🟦 CLUSTERS — invisible by default, exclude Title_ layers
           ============================================================ */
        g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) path,
        g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) polygon,
        g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) rect,
        g[id]:not([id^="text"]):not([id^="logo"]):not([id^="Title"]):not([id^="title"]) polyline {
          fill: transparent;
          stroke-width: 2;
          transition: fill .3s ease, stroke-width .3s ease;
        }

        /* ============================================================
           📌 TITLE_ LAYERS — static, always visible, non-interactive
           ============================================================ */
        g[id^="Title"], g[id^="title"] {
          pointer-events: auto !important;
        }
        g[id^="Title"] *, g[id^="title"] * {
          transition: none !important; 
          opacity: 1 !important;
        }

        /* ============================================================
           ✨ AUTO-HIGHLIGHT ANIMATION (pulse)
           ============================================================ */
        @keyframes pulse {
          0% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
          50% { fill: rgba(146,26,29,0.5); stroke-width: 4; }
          100% { fill: rgba(146,26,29,0.2); stroke-width: 2; }
        }
        g[id].auto-highlight path,
        g[id].auto-highlight polygon,
        g[id].auto-highlight rect,
        g[id].auto-highlight polyline {
          animation: pulse 1.2s infinite;
        }

        /* ============================================================
           🎬 VIDEO + SVG GENERAL STYLING
           ============================================================ */
        video {
          width: 100%;
          height: 100vh;
          object-fit: cover;
        }

        svg {
          width: 100% !important;
          height: 100vh !important;
          display: block;
          overflow: hidden;
        }

        img.fade-in {
          animation: fadeIn 1s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        /* ============================================================
           🤍 TEXT LAYERS
           ============================================================ */
        g[id^="text"] * {
          stroke: none !important;
        }

        /* White text */
        g[id^="text"] [id="white"],
        g[id^="text"] path#white {
          fill: #ffffff !important;
        }

        g[id^="logo"] * {
          stroke: none !important;
        }

        /* White logo */
        g[id^="logo"] [id="white"],
        g[id^="logo"] path#white {
          fill: #ffffff !important;
        }

        /* Red text */
        g[id^="text"] [id="color"],
        g[id^="text"] path#color {
          fill: #8f1a1e !important;
        }

        /* Mosque override */
        g[id^="Mosque1"] [id="color"],
        g[id^="Mosque1"] path#color {
          fill: #ffffff !important;
        }
        g[id^="Mosque1"] [id="color"],
        g[id^="Mosque1"] rect#color {
          fill: #8f1a1e !important;
        }

        /* Worker override */
        g[id^="Worker_x2019_s"] [id="color"],
        g[id^="Worker_x2019_s"] rect#color {
          fill: #8f1a1e !important;
        }
        g[id^="Worker_x2019_s"] [id="white"],
        g[id^="Worker_x2019_s"] rect#white {
          fill: #ffffff !important;
        }
        g[id^="Title"], g[id^="title"] {
          pointer-events: auto !important;
        }

        g[id^="Title"] rect,
        g[id^="Title"] polygon,
        g[id^="title"] rect,
        g[id^="title"] polygon {
          fill: #8f1a1e !important;
          stroke: none !important;
        }

        g[id^="Title"] path,
        g[id^="title"] path {
          fill: #ffffff !important;
          stroke: none !important;
        }

        g[id="Title_Mosque"] rect[x="7004.21"][y="1452.51"],
        g[id="Title_Mosque"] rect[x="7511.13"][y="1555.97"] {
          fill: white !important;
        }

        g[id="title_playground"] rect[x="5946.01"][y="2669.69"],
        g[id="title_playground"] rect[x="6984.08"][y="2669.67"] {
          fill: white !important;
        }

        g[id="Title_dining_hall"] rect[x="4264.12"][y="3933.55"] {
          fill: white !important;
        }

        g[id="Title_RUNNING_TRACK"] rect[x="1503.72"][y="3079.34"],
        g[id="Title_RUNNING_TRACK"] rect[x="1501.98"][y="3079.34"] {
          fill: white !important;
        }

        g[id="title_EngineersManagers"] rect[x="5652.89"][y="1192.74"],
        g[id="title_EngineersManagers"] rect[x="7285.54"][y="1109.46"] {
          fill: white !important;
        }

        g[id="Title_clinic"] rect[x="6515.38"][y="2085.59"],
        g[id="Title_clinic"] rect[x="7693.2"][y="2013.48"] {
          fill: white !important;
        }
        
        path[id="white"]{ fill: white !important;}
        circle{fill: #dd9932 !important;}

        .fade-in {
          opacity: 0;
          animation: fadeIn 0.6s ease forwards;
        }

        @keyframes fadeIn {
          to { opacity: 1; }
        }
        
        .fade-overlay {
          position: absolute;
          inset: 0;
          background-color: black;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.5s ease-in-out;
          z-index: 100;
        }

        .fade-overlay.active {
          opacity: 0.7;
        }
          @media (max-width: 768px) {
  .mobile-back-button {
        top: 1rem !important;
        left: 15px !important;
        width: 1rem !important;
        height: 1rem !important;
    }
  .mobile-home-button {
        top: 1rem !important;
        left: 2.2rem !important;
        width: 1rem !important;
        height: 1rem !important;
    }
}

      `}</style>
    </div >
  );
}